import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// Using Lucide-react for the Menu/X icons
import { Menu, X, Bell, Search } from 'lucide-react';

const TopBar = ({ onMenuClick, isSidebarOpen }) => {
  const navigate = useNavigate();
  
  // --- AUTHENTICATION CHECK ---
  useEffect(() => {
    const authStatus = localStorage.getItem('isLoggedIn');
    if (authStatus !== 'true') {
      // Redirect to login if not authenticated
      navigate('/');
    }
  }, [navigate]);

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const profilePicPlaceholder = "https://placehold.co/32x32/AE7D54/ffffff?text=Admin";

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [message, setMessage] = useState('');
  const [showMessageBox, setShowMessageBox] = useState(false);

  const handleProfileClick = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const showCustomMessage = (msg) => {
    setMessage(msg);
    setShowMessageBox(true);
    setTimeout(() => {
      setShowMessageBox(false);
      setMessage('');
    }, 3000);
  };

  const handleLogout = () => {
    // Clear auth data
    localStorage.removeItem('isLoggedIn');
    showCustomMessage("Logged out successfully!");
    setShowProfileMenu(false);
    
    // Redirect to login page
    setTimeout(() => {
        navigate('/');
    }, 1000);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

        body {
            font-family: 'Inter', sans-serif;
            margin: 0;
            background-color: #f3f4f6;
        }

        .top-nav-container {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 0;
          position: sticky;
          top: 0;
          z-index: 1100;
        }

        .main-content-wrapper {
          width: 100%;
          background-color: white;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
        }

        .top-nav-row-one {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.75rem 1.5rem;
          gap: 1rem;
        }

        .toggle-btn {
          display: none;
          align-items: center;
          justify-content: center;
          background-color: #f9fafb;
          border: 1px solid #e5e7eb;
          padding: 0.5rem;
          border-radius: 0.5rem;
          cursor: pointer;
          color: #AE7D54;
        }

        @media (max-width: 1024px) {
          .toggle-btn { display: flex; }
        }

        .search-box {
          display: flex;
          align-items: center;
          background-color: #f9fafb;
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          color: #6b7280;
          flex-grow: 1;
          max-width: 24rem;
        }

        .search-input {
          border: none;
          background: transparent;
          flex-grow: 1;
          outline: none;
          font-size: 0.875rem;
          margin-left: 8px;
        }

        .bell-profile-group {
          display: flex;
          align-items: center;
          gap: 1.25rem;
          position: relative;
        }

        .profile-pic {
          width: 2.2rem;
          height: 2.2rem;
          border-radius: 50%;
          border: 2px solid #AE7D54;
          cursor: pointer;
        }

        .profile-menu {
          position: absolute;
          top: 120%;
          right: 0;
          background-color: white;
          border-radius: 0.5rem;
          box-shadow: 0 10px 15px rgba(0,0,0,0.1);
          padding: 0.5rem;
          min-width: 180px;
          border: 1px solid #eee;
        }

        .profile-menu-logout-btn {
            width: 100%;
            padding: 0.6rem;
            background-color: #fee2e2;
            color: #dc2626;
            border: none;
            border-radius: 6px;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
        }

        .message-box {
          position: fixed;
          top: 20px;
          right: 20px;
          background-color: #333;
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          z-index: 9999;
          transform: translateY(-100px);
          transition: 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        .message-box.show { transform: translateY(0); }
      `}</style>

      <div className="top-nav-container">
        <div className="main-content-wrapper">
          <div className="top-nav-row-one">
            
            <button className="toggle-btn" onClick={onMenuClick}>
              {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>

            <div className="search-box">
              <Search size={18} />
              <input type="text" placeholder="Search dashboard..." className="search-input" />
            </div>

            <div className="bell-profile-group">
              <Bell size={22} style={{ cursor: 'pointer', color: '#666' }} />
              
              <img 
                src={profilePicPlaceholder} 
                alt="User" 
                className="profile-pic" 
                onClick={handleProfileClick} 
              />
              
              {showProfileMenu && (
                <div className="profile-menu">
                  <div style={{ padding: '8px', fontSize: '13px', color: '#666' }}>
                    Logged in as <b>Admin</b>
                  </div>
                  <hr style={{ border: '0.5px solid #eee', margin: '4px 0' }} />
                  <button className="profile-menu-logout-btn" onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={`message-box ${showMessageBox ? 'show' : ''}`}>
        {message}
      </div>
    </>
  );
};

export default TopBar;